import { render, staticRenderFns } from "./About_ISFAL.vue?vue&type=template&id=59ce42f0&scoped=true&"
import script from "./About_ISFAL.vue?vue&type=script&lang=js&"
export * from "./About_ISFAL.vue?vue&type=script&lang=js&"
import style0 from "./About_ISFAL.vue?vue&type=style&index=0&id=59ce42f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ce42f0",
  null
  
)

export default component.exports